import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const storedToken = localStorage.getItem('token');
      if (storedToken) {
        try {
          const response = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${storedToken}` }
          });
          setUser(response.data);
          setToken(storedToken);
        } catch (error) {
          localStorage.removeItem('token');
          setToken(null);
          setUser(null);
        }
      }
      setLoading(false);
    };
    initAuth();
  }, []);

  const login = async (email, password, userType) => {
    const endpoint = userType === 'admin' 
      ? '/auth/login/admin' 
      : userType === 'business_owner' 
        ? '/auth/login/business' 
        : '/auth/login/community';
    
    const response = await axios.post(`${API}${endpoint}`, { email, password });
    const { token: newToken, user_id, name, user_type } = response.data;
    
    localStorage.setItem('token', newToken);
    setToken(newToken);
    setUser({ id: user_id, name, user_type, email });
    
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  const registerCommunity = async (data) => {
    const response = await axios.post(`${API}/auth/register/community`, data);
    return response.data;
  };

  const registerBusiness = async (data) => {
    const response = await axios.post(`${API}/auth/register/business`, data);
    return response.data;
  };

  return (
    <AuthContext.Provider value={{
      user,
      token,
      loading,
      login,
      logout,
      registerCommunity,
      registerBusiness,
      isAuthenticated: !!token,
      isCommunityMember: user?.user_type === 'community_member',
      isBusinessOwner: user?.user_type === 'business_owner',
      isAdmin: user?.user_type === 'admin'
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
